import { createContext, useContext } from 'react';
import type { CompanyLocale } from '@/utils/locale';
import type { PortalCompanyRow, PortalMeRow } from './hooks/portalClient';

export interface PortalContextValue {
  slug: string;
  company: PortalCompanyRow;
  me: PortalMeRow;
  locale: CompanyLocale;
  timezone: string;
  formatMoney: (amount: number | null | undefined) => string;
  /** Long date ("8 September 2026"), date-only and timezone safe. */
  formatDate: (value: string | null | undefined) => string;
  /** Compact date ("8 Sep 2026") for list rows. */
  formatShortDate: (value: string | null | undefined) => string;
  /** Tenant brand colour (hex) or the theme primary. */
  primaryColor: string;
}

export const PortalContext = createContext<PortalContextValue | undefined>(undefined);

export function usePortal(): PortalContextValue {
  const ctx = useContext(PortalContext);
  if (!ctx) throw new Error('usePortal must be used inside CustomerRoute');
  return ctx;
}
